<template>
    <div class="download_nav" :class="ifShow?'show':'hide'">
        <div class="content">
            <p class="tip">来 在惠州 晒一张</p>
            <a class="btn" @click="openApp">立即打开</a>
        </div>
    </div>
</template>
<style lang="scss" scoped>
    @import "../../assets/scss/mixin.scss";
    .download_nav{
        width: 100%;
        .content{
            height: 155px;
            background: url(./imgs/0.gif) no-repeat 19px 36px/133px auto,
                        url(./imgs/1.png) no-repeat 107px 30px/84px auto,
                        url(./imgs/2.png) no-repeat 210px 54px/139px auto #fff;
            display: flex;
            @include hairline(bottom,#eee);
        }

        position: fixed !important;
        left:0;
        top:0;

        z-index: 1000000 !important;

        transition: 0.4s ease;
        &.show{
            transform: translateY(0px);
        }

        &.hide{
            transform: translateY(-200px);
        }

        &::after{
            content:'';
            position: absolute;
            z-index: -1;
        }
    }
    .tip{
        flex:1;
        padding-top: 100px;
        padding-left: 206px;
        @include px2px('font-size',22);
        color: #999;
        line-height: 1;
    }
    .btn{
        display: block;
        width: 176px;
        height: 71px;
        line-height: 71px;
        text-align: center;
        color: #fff;
        background: $mainBlue;
        border-radius: 9px;
        @include px2px('font-size',30);
        margin-right:30px;
        margin-top:50px;
        text-decoration: none;
        &:active{
            opacity:.8;
        }
    }

</style>

<script>
export default {
    data () {
        return {
            ifShow:true
        }
    },
    methods: {
        openApp () {
            let self = this;
            switch ( self.$route.name ) {
                case 'topic':
                    location.href='https://www.xiziquan.com/quan_to.php?type=po_tag&tag_id=' + self.$route.params.tag_id;
                    break;
                case 'detail':
                    location.href='https://www.xiziquan.com/quan_to.php?type=po&pid='+self.$route.params.po_id;
                    break;
                default:
                    location.href = "https://www.xiziquan.com/quan_to.php";
                    break;
            }
        }
    },
    mounted () {
        let self = this;
        //主引导下载悬浮栏
        var preScrollTop = 0;
        var oNav = document.querySelector('.download_nav');
        var h = oNav.offsetHeight;
        window.addEventListener('scroll', () => {
            var sTop = document.body.scrollTop;
            if(sTop - preScrollTop > 0 && sTop > h){
                self.ifShow = false;
            }else{
                self.ifShow = true;
            }
            preScrollTop = sTop;
        });
    }
}
</script>



// WEBPACK FOOTER //
// DownloadNav.vue?788ae5db